import { WorkoutExercise } from '@src/data/workout-exercise'
import Store, { WorkoutLiveData } from '../../state/store'
import { WORKOUT_SIMULTATOR_STATE } from '@src/util/constants'

export const DEFAULT_WORKOUT_DATA = {
  elapsedTime: 0,
  state: WORKOUT_SIMULTATOR_STATE.PREVIEW, // starting in preview
  repetitions: 0,
  currentExerciseIndex: 0,
  isWorkoutPaused: false,
  totalElapsedTime: 0,
  exerciseDone: false,
  workoutDone: false
}

let defaultScreenCountdownLen

export class LiveWorkoutDataRetriever {
  data: WorkoutLiveData
  intervalId
  workoutExercises: WorkoutExercise[]
  timeoutId

  store: Store

  constructor (store) {
    this.store = store
  }

  resetData () {
    this.data = {
      ...DEFAULT_WORKOUT_DATA
    }
    this.store.commit('setWorkoutLiveData', this.data)
  }

  updateData () {
    const now = new Date()
    const milisecondsUntilNextSecond = 1000 - now.getMilliseconds()
    this.store.commit('setWorkoutLiveData', this.data)
    this.timeoutId = setTimeout(() => {
      this.store.commit('setWorkoutLiveData', this.retrieveData())
      this.updateData()
    }, milisecondsUntilNextSecond)
  }

  retrieveData () {
    const workoutRunning = this.data.state === WORKOUT_SIMULTATOR_STATE.RUNNING && !this.data.isWorkoutPaused
    if (this.data.state === WORKOUT_SIMULTATOR_STATE.END) {
      this.stop()
    } else if (this.data.state === WORKOUT_SIMULTATOR_STATE.PREVIEW) {
      if (this.data.previewTime === 0) {
        this.data = {
          ...DEFAULT_WORKOUT_DATA,
          previewTime: defaultScreenCountdownLen,
          state: WORKOUT_SIMULTATOR_STATE.RUNNING,
          currentExerciseIndex: this.data.currentExerciseIndex,
          totalElapsedTime: this.data.totalElapsedTime
        }
      } else {
        if (this.data.previewTime) this.data.previewTime--
      }
    } else if (workoutRunning) {
      const currentExercise = this.workoutExercises[this.data.currentExerciseIndex]
      const { durationMedium } = currentExercise.exercise
      this.data.elapsedTime++

      let exerciseDuration = Math.round(durationMedium * (currentExercise.initialExerciseConfig!.repetitions || 1))
      this.data.exerciseDone = this.data.elapsedTime === exerciseDuration

      // count every repetition at the last quarter of the repetition.
      if (this.data.elapsedTime && this.data.elapsedTime > (durationMedium * (this.data.repetitions + 1)) - (durationMedium / 4)) {
        this.data.repetitions = Math.round(this.data.elapsedTime / durationMedium)
      }

      if (this.data.exerciseDone && this.data.currentExerciseIndex < this.workoutExercises.length - 1) {
        this.data.exerciseDone = true
        this.data.totalElapsedTime += exerciseDuration
      } else if (this.data.exerciseDone && this.data.currentExerciseIndex === this.workoutExercises.length - 1) {
        this.data.workoutDone = true
        this.data.totalElapsedTime += exerciseDuration
      }
    }

    return this.data
  }

  stop () {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }

  start ({ workoutExercises, screenCountdownLen }) {
    this.workoutExercises = workoutExercises
    this.resetData()
    this.data = {
      ...this.data,
      previewTime: screenCountdownLen
    }
    defaultScreenCountdownLen = screenCountdownLen

    if (!this.timeoutId) this.updateData()
  }

  pause () {
    this.data.isWorkoutPaused = true
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
      this.store.commit('setWorkoutLiveData', this.data)
    }
  }

  resume () {
    this.data.isWorkoutPaused = false

    if (!this.timeoutId) {
      this.store.commit('setWorkoutLiveData', this.data)
      this.updateData()
    }
  }

  goToState (state) {
    if (state === WORKOUT_SIMULTATOR_STATE.PREVIEW) {
      this.data.currentExerciseIndex = this.data.currentExerciseIndex + 1
    }
    this.data.state = state
  }
}
